import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { CurveFittingAlgorithm } from 'Components/Worksheets/Shared/types';
import React from 'react';
import { Field, RadioGroup, TextOutput } from '../../../../../../Core';
import { withInjectedProps } from '../../../../../../Core/InjectedPropsContext';
import { Grid, ListFieldSection } from '../../../../../../Layout';

let ResultsCalculatedPropertiesSection: React.FC<IWorksheetComponent> = () => (
  <>
    <ListFieldSection heading="Calculated Properties">
      <Field input={<TextOutput />} label="Total Dry Mass of Specimen" name="WholePortion.Masses.DryMass" />
      <Field
        input={<RadioGroup />}
        label="Curve Fitting"
        name={'Results.ChartOptions.CurveFittingAlgorithm'}
        options={[
          { label: 'Linear', value: CurveFittingAlgorithm.Linear },
          { label: 'Bézier curve', value: CurveFittingAlgorithm.Bezier },
        ]}
      />
    </ListFieldSection>
    <ListFieldSection wide>
      <Grid
        center={true}
        colWidths={Array(6).fill(60)}
        colHeaders={['D85', 'D60', 'D50', 'D30', 'D15', 'D10']}
        data={[
          [
            <Field input={<TextOutput />} name="Results.D85" label="D85" />,
            <Field input={<TextOutput />} name="Results.D60" label="D60" />,
            <Field input={<TextOutput />} name="Results.D50" label="D50" />,
            <Field input={<TextOutput />} name="Results.D30" label="D30" />,
            <Field input={<TextOutput />} name="Results.D15" label="D15" />,
            <Field input={<TextOutput />} name="Results.D10" label="D10" />,
          ],
        ]}
      />
    </ListFieldSection>
    <ListFieldSection>
      <Field input={<TextOutput />} label="Coefficient of Uniformity (Cu)" name="Results.CoefficientOfUniformity" />
      <Field input={<TextOutput />} label="Coefficient of Curvature (Cc)" name="Results.CoefficientOfCurvature" />
    </ListFieldSection>
  </>
);

ResultsCalculatedPropertiesSection = withInjectedProps(ResultsCalculatedPropertiesSection);

export { ResultsCalculatedPropertiesSection };
export default ResultsCalculatedPropertiesSection;
